import React, {lazy} from 'react'
import './index.css'
import './Services/Axios/axiosConfig';
import { createRoot } from 'react-dom/client';
import { App } from './App'
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { Login } from './Component/Interface/Login/Login';
import { Accueil } from './Component/Interface/Accueil/Accueil';
import { MonCompte } from './Component/Interface/MonCompte/MonCompte';
import { Dashboard } from './Component/Interface/User/Affichage/Dashboard/Dashboard';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { NavigateProvider } from './Context/NavigateContext';

//Chargement "lazy" pour ne pas que les scripts js soient chargés automatiquement pour la partie admin
const AdminLayout = lazy(()=>import('./Component/Admin/AdminLayout'));
const ClientsAdmin = lazy(()=>import('./Component/Admin/AffichageAdmin/ClientsAdmin/ClientsAdmin'));
const EnseigneAdmin = lazy(()=>import('./Component/Admin/AffichageAdmin/EnseigneAdmin/EnseigneTabsAdmin'));
const MagasinAdmin = lazy(()=>import('./Component/Admin/AffichageAdmin/MagasinAdmin/MagasinAdmin'));
const PacksAdmin = lazy(()=>import('./Component/Admin/AffichageAdmin/PacksAdmin/PacksAdmin'));
const IndexationAdmin = lazy(()=>import('./Component/Admin/AffichageAdmin/IndexationAdmin/IndexationLayout'))
const CampagneGALECAdmin = lazy(()=>import('./Component/Admin/AffichageAdmin/CampagneAdmin/CampagneGALECAdmin'))
const CampagneSCAMARKAdmin = lazy(()=>import('./Component/Admin/AffichageAdmin/CampagneAdmin/CampagneScamarkAdmin'));
const CataMIDISAdmin = lazy(()=>import('./Component/Admin/AffichageAdmin/CampagneAdmin/CataMidisAdmin'));
const SpotExpressAdmin = lazy(()=>import('./Component/Admin/AffichageAdmin/SpotExpressAdmin/SpotExpressAdmin'));
const DuplicationAdmin = lazy(()=>import('./Component/Admin/AffichageAdmin/DuplicationAdmin/DuplicationAdmin'));
const MusiquesThematiquesAdmin = lazy(()=>import('./Component/Admin/AffichageAdmin/MusiquesThematiquesAdmin/MusiquesThematiquesAdmin'));
const ComMidis = lazy(()=>import('./Component/Admin/AffichageAdmin/COM_MIDIS_Admin/ComMidisAdmin'));
const AlertesEmails = lazy(()=>import('./Component/Admin/AffichageAdmin/AlertesEmailsAdmin/AlertesEmailsAdmin'));
const StatistiquesCommandes = lazy(()=>import('./Component/Admin/AffichageAdmin/StatistiquesCommandesAdmin/StatistiquesCommandesAdmin'));

const RecuperationIdEtMdp = lazy(()=>import('./Component/Interface/RecuperationIdEtMdp/RecuperationIdEtMdp'));

//Chargement "lazy" pour ne pas que les scripts js soient chargés automatiquement pour la partie utilisateur
const HorairesPermanents = lazy(()=>import('./Component/Interface/User/Affichage/HorairesPermanents/HorairesOuvertures'));
const HorairesExceptionnelles = lazy(()=>import('./Component/Interface/User/Affichage/HorairesExceptionnelles/OuvFermExceptionnelles'));
const MessagesPermanents = lazy(()=>import('./Component/Interface/User/Affichage/MessagesPermanents/MessagesPermanents'));
const MusiqueThematique = lazy(()=>import('./Component/Interface/User/Affichage/MusiqueThematique/MusiquesThematiques'));
const TempsCalme = lazy(()=>import('./Component/Interface/User/Affichage/TempsCalme/TempsCalme'));
const CampagnesGALEC = lazy(()=>import('./Component/Interface/User/Affichage/Campagnes/Galec/CampagnesGALEC'));
const CampagnesSCAMARKClient = lazy(()=>import('./Component/Interface/User/Affichage/Campagnes/Scamark/CampagnesScamarkClient'));
const SpotExpress = lazy(()=>import('./Component/Interface/User/Affichage/Spots/Express/SpotExpress'));
const SpotIntegrer = lazy(()=>import('./Component/Interface/User/Affichage/Spots/Integrer/SpotIntegrer'));
const CataloguesMidis = lazy(()=>import('./Component/Interface/User/Affichage/Campagnes/CatalogueMidis/CataloguesMidis'));

const theme = createTheme({
  breakpoints: {
   values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: '#0066cc',
    },
    warning:{
      main:'#ff6633'
    }
  },
  typography:{
    allVariants: {
      fontFamily: ['"Montserrat"', 'Open Sans'].join(','),
      fontWeight:400  
    }
  }
});

const container = document.getElementById('root');
const root = createRoot(container!) //if you use TypeScript
root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <NavigateProvider>
        <Routes>
          <Route path='/' element={<App />}>
            <Route index element={<Navigate to="login" replace />} />
            <Route path='login' element={<Login/>}/>
            <Route path='helpLogin' element={<RecuperationIdEtMdp/>}/>
            <Route path='admin' element={<AdminLayout/>}>
              <Route index element={<Navigate to="magasins" replace />} />
              <Route path='clients' element={<ClientsAdmin/>}/>
              <Route path='enseignes' element={<EnseigneAdmin/>}/>
              <Route path='magasins' element={<MagasinAdmin/>}/>
              <Route path='packs' element={<PacksAdmin/>}/>
              <Route path='indexation' element={<IndexationAdmin/>}/>
              <Route path='galec' element={<CampagneGALECAdmin/>}/>
              <Route path='scamark' element={<CampagneSCAMARKAdmin/>}/>
              <Route path='cataMidis' element={<CataMIDISAdmin/>}/>
              <Route path='spotExpress' element={<SpotExpressAdmin/>}/>
              <Route path='duplications' element={<DuplicationAdmin/>}/>
              <Route path='thematiques' element={<MusiquesThematiquesAdmin/>}/>
              <Route path='comMidis' element={<ComMidis/>}/>
              <Route path='alertes' element={<AlertesEmails/>}/>
              <Route path='statistiques' element={<StatistiquesCommandes/>}/>
            </Route>
            <Route path='accueil' element={<Accueil/>}>
              <Route index element={<Dashboard />} />
              <Route path='horairesPermanents' element={<HorairesPermanents/>}/>
              <Route path='horairesExceptionnelles' element={<HorairesExceptionnelles/>}/>
              <Route path='messagesPermanents' element={<MessagesPermanents/>}/>
              <Route path='musiqueThematique' element={<MusiqueThematique/>}/>
              <Route path='tempsCalme' element={<TempsCalme/>}/>
              <Route path='galec' element={<CampagnesGALEC/>}/>
              <Route path='scamark' element={<CampagnesSCAMARKClient/>}/>
              <Route path='spotExpress' element={<SpotExpress/>}/>
              <Route path='spotIntegrer' element={<SpotIntegrer/>}/>
              <Route path='catalogueMidis' element={<CataloguesMidis/>}/>
            </Route>
            <Route path='monCompte' element={<MonCompte/>}/>
          </Route>
        </Routes>
      </NavigateProvider>
    </ThemeProvider>
  </BrowserRouter>
);

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root'),
// )
